/* eslint-disable @typescript-eslint/no-use-before-define */
import { Typography } from '@euler/app/components/typography';
import {
  getDefectiveLevelBgColor,
  getDefectiveLevelColor,
  getDefectiveLevelText,
} from '@euler/functions/getDefectiveLevel';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { DefectiveLevel } from '@euler/model';
import { memo, useCallback } from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';
import { useTheme } from 'styled-components';

export const ItemOptionCell = memo(
  ({
    index,
    title,
    defectiveLevel,
    selected,
    style,
    onSelected,
  }: {
    index: number;
    title: string;
    defectiveLevel: DefectiveLevel;
    selected?: boolean;
    style?: StyleProp<ViewStyle>;
    onSelected?: (index: number) => void;
  }) => {
    const theme = useTheme();
    const { rpx } = useResponsiveContext();
    const {
      inspection: {
        siteInspection: {
          itemCard: {
            unselectedOptionTextColor,
            unselectedOptionBgColor,
            optionBorderColor,
          },
        },
      },
    } = theme;
    const onOptionPress = useCallback(() => {
      if (selected) return;
      onSelected?.(index);
    }, [index, onSelected, selected]);
    const textColor = selected
      ? getDefectiveLevelColor(theme, defectiveLevel)
      : unselectedOptionTextColor;
    const bgColor = selected
      ? getDefectiveLevelBgColor(theme, defectiveLevel)
      : unselectedOptionBgColor;
    const borderColor = selected ? textColor : optionBorderColor;
    const statusText = selected ? getDefectiveLevelText(defectiveLevel) : '';
    return (
      <TouchableOpacity
        onPress={onOptionPress}
        css={`
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          flex-wrap: nowrap;
          background-color: ${bgColor};
          border-width: 1px;
          border-color: ${borderColor};
          height: ${rpx(39)}px;
          border-radius: ${rpx(5)}px;
          padding: 0 ${rpx(15)}px;
        `}
        style={style}
      >
        <Typography.Label
          light
          size={rpx(15)}
          css={`
            flex: 1;
          `}
          color={textColor}
          numberOfLines={1}
        >
          {title}
        </Typography.Label>
        <Typography.Label
          light
          size={rpx(15)}
          color={textColor}
          numberOfLines={1}
        >
          {statusText}
        </Typography.Label>
      </TouchableOpacity>
    );
  },
);
